<template>
    <div class="container-switcher2" style='display:inline-flex'>
        <template v-if='supported'>
            <!-- <div class="point"></div> -->
            <select ref='switcher' class="switcher-l2" id='lang-switcher' :value='lang' @change='languageChanged'>
                <option value="ru" lang="ru">Русский</option>
                <option value="en" lang="en">English</option>
            </select>
            <img :src='`/static/images/flags/${normalize(lang)}.svg`' style='width:16px;' alt='langauge icon' />
        </template>
        <template v-else>
            <span style='width:24px;margin-right: 15px' />
            <select class="switcher-l2" id='lang-switcher' :value='lang' @change='languageChanged'>
                <option value="ru" lang="ru">Русский</option>
                <option value="en" lang="en">English</option>
                <option :value="lang" :lang="lang">{{names[lang]}}</option>
            </select>        
        </template>
    </div>
</template>

<script>
import i18n from '@root/components/i18n';

export default { 
    name: 'switch-language',
    data: function() { 
        return {
            names: {
                "ar": "العربية",
                "ast": "Asturianu",
                "az": "Azərbaycanca",
                "bg": "Български",
                "nan": "Bân-lâm-gú / Hō-ló-oē",
                "be": "Беларуская",
                "ca": "Català",
                "cs": "Čeština",
                "cy": "Cymraeg",
                "da": "Dansk",
                "de": "Deutsch",
                "et": "Eesti",
                "el": "Ελληνικά",
                "en": "English",
                "es": "Español",
                "eo": "Esperanto",
                "eu": "Euskara",
                "fa": "فارسی",
                "fr": "Français",
                "gl": "Galego",
                "hy": "Հայերեն",
                "hi": "हिन्दी",
                "hr": "Hrvatski",
                "id": "Bahasa Indonesia",
                "it": "Italiano",
                "he": "עברית",
                "ka": "ქართული",
                "la": "Latina",
                "lv": "Latviešu",
                "lt": "Lietuvių",
                "hu": "Magyar",
                "mk": "Македонски",
                "arz": "مصرى",
                "ms": "Bahasa Melayu",
                "min": "Bahaso Minangkabau",
                "nl": "Nederlands",
                "ja": "日本語",
                "no": "Norsk (bokmål)",
                "nn": "Norsk (nynorsk)",
                "ce": "Нохчийн",
                "uz": "Oʻzbekcha / Ўзбекча",
                "pl": "Polski",
                "pt": "Português",
                "kk": "Қазақша / Qazaqşa / قازاقشا",
                "ro": "Română",
                "ru": "Русский",
                "ceb": "Sinugboanong Binisaya",
                "sk": "Slovenčina",
                "sl": "Slovenščina",
                "sr": "Српски / Srpski",
                "sh": "Srpskohrvatski / Српскохрватски",
                "fi": "Suomi",
                "sv": "Svenska",
                "ta": "தமிழ்",
                "tt": "Татарча / Tatarça",
                "th": "ภาษาไทย",
                "tg": "Тоҷикӣ",
                "azb": "تۆرکجه",
                "tr": "Türkçe",
                "uk": "Українська",
                "ur": "اردو",
                "vi": "Tiếng Việt",
                "vo": "Volapük",
                "war": "Winaray",
                "zh": "中文",
                "ko": "한국어",                
            }
        }
    },
    mixins: [i18n],
    props: [],
    components: {
    },
    computed: {
        supported() {
            return this.lang == "ru" || this.lang == "en";
        }
    },
    created: function () {
    },
    mounted: function() {
    },
    methods: {
        async languageChanged(e) {
            const newLanguage = e.target.value;
            console.log("language changed to", newLanguage);
            const search = location.search.substring(1).split('&').map(c => c.split('=')).filter(c => c[0] !== "").reduce((a, b) => { a[b[0]] = (b.length > 1 ? b[1] : true); return a; }, {});
            search.lang = newLanguage;
            const path = location.pathname + "?" + Object.entries(search).map(c=>`${c[0]}=${c[1]}`).join("&");

            const response = await fetch('/api/switch-language/' + newLanguage, { method: 'POST' });
            let text = await response.text();
            console.log("Result", text);
            
            location.reload();
        },
        normalize(lang) {
            if (lang == 'en') 
                return 'gb';
            return lang;
        },
    }
}
</script>

<style  lang="scss" scoped>
    .container-switcher2 {
        position: relative;
        //margin-top: 8px;
        //margin-left: 56px;//margin-left: 16px;
        &:hover {
            .point {
                display: block;
            }
        }
        
        .switcher-l2 {
            position: relative;
            cursor: pointer;
            box-sizing: border-box;
            background: none;
            border-radius: 100px; 
            outline: none;
            border: none;
            color: #808080;
            font-size: 16px;
            //font-weight: 600;
            padding-left: 0;
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
            background-image: url(/static/images/demo/home/down_switcher_w.svg);
            background-repeat: no-repeat, repeat;
            background-position: right 0 top 60%, 0 0;
            padding-right: 8px;
            //min-width: 160px;
            &:hover {
                color: #6179E0;
            }
        }
        .switcher-l2::-ms-expand { display: none; }

        option { 
            color: grey;
        }
        .point {
            position: absolute;
            left: -20px;
            top: 9px;
            background: #6179E0;
            height: 6px;
            width: 6px;
            border-radius: 50px;
            display: none;
        }
    }

</style>